import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChartsModule } from 'ng2-charts';
import { ApiService } from './api.service';
import { AuthService } from './shared/auth/auth.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppService } from './app.service';
import { AuthInterceptor } from './shared/auth/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeFr from '@angular/common/locales/fr';
import {registerLocaleData} from "@angular/common";
import { SignalRService } from './signalr.service';
registerLocaleData(localeFr);

export function initApp(_appService: AppService, _apiService: ApiService) {
    return () => new Promise<void>((resolve, reject) => {
      Promise.all([
        _appService.getAppVersion()
      ]).then(() => {
        console.log("ABWORKFLOW CORE LOADED");
        resolve();
      }, (errors) => { 
        window.document.getElementById('loading-spinner').style.display = 'none';
        window.document.getElementById('loading-error').style.display = 'block';
        console.log("FAILED TO LOAD ABWORKFLOW CORE");
        reject(errors);
      });
    });
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, ChartsModule, HttpClientModule, BrowserAnimationsModule],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ApiService,
    AuthService,
    AppService,
    SignalRService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide : APP_INITIALIZER, multi : true, deps : [AppService, ApiService], useFactory : initApp},
    { provide: LOCALE_ID, useValue: 'fr-FR'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
